'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

/**
 * Export as Tailwind Preset.
 */ const preset = {
    content: [],
    variants: {
        borderGradient: [
            'hover'
        ],
        extend: {
            outline: [
                'focus-visible'
            ],
            borderStyle: [
                'hover'
            ],
            borderWidth: [
                'hover',
                'last'
            ],
            backgroundColor: [
                'disabled',
                'active'
            ],
            transitionDuration: [
                'hover'
            ],
            margin: [
                'last'
            ],
            padding: [
                'first'
            ]
        }
    }
};

exports.default = preset;
//# sourceMappingURL=variants.js.map
